import SetNewPasswordForm from '@src/features/tenant/auth/SetNewPasswordForm';
import TenantCenterCardLayout from '@src/layouts/tenant/TenantCenterCardLayout';

function TenantSetNewPassword() {
  return (
    <>
      <TenantCenterCardLayout>
        <SetNewPasswordForm />
      </TenantCenterCardLayout>
    </>
  );
}

export default TenantSetNewPassword;
